import React from 'react';

import {BoxParams} from './Box';
import Row from './Row';
import UsedLetters from './UsedLetters';
import GameOver from './GameOver';
import {useEventListener} from '../util/useEventListener';
import { isAWord, getTodaysWord, getWordNumber, calculateResults } from '../util/Brain';

const allowOnlyValidWords = true;
const MAX_LETTERS = 5;
const MAX_TRIES = 6;

const SELECTED_WORD:string[] = getTodaysWord();

const KEY_ROWS:Array<string> = [
  'qwertyuiopå',
  'asdfghjklöä',
  'zxcvbnm'
];
const ALLOWED_KEYS:string[] = KEY_ROWS.join('').split('')

console.log(`#${getWordNumber()} 🤨 Tätä kai etsit:`);
console.log(`%c${SELECTED_WORD.join('')}`, 'background: #333333; color: #333333');

type BoardProps = {
  addTry: Function;
  initialState: string[]
}
const Board = ({addTry, initialState}:BoardProps) => {
  const previousTries = React.useMemo(() => {
    return initialState.map((guess) => {
      const results = calculateResults(guess, SELECTED_WORD.join(''))
      return results
    })
  }, [initialState]);

  const [tries, setTries] = React.useState<Array<Array<BoxParams>>>(previousTries);
  const [currentRow, setCurrentRow] = React.useState<number>(previousTries.length);
  const [currentLetters, setCurrentLetters] = React.useState<BoxParams[]>([]);

  const [gameIsOver, playerWon] = React.useMemo(() => {
    const perfectAnswer = tries.find((guess) => {
      return guess.filter(i => i.answer === 'PERFECT').length === 5
    })

    if(perfectAnswer) {
      return [true, true]
    }

    const allGuessesUsed = tries.length === MAX_TRIES;
    return [allGuessesUsed, false];
  }, [tries])

  const onClickLetter = React.useCallback((key) => {
    if (gameIsOver) {
      return;
    }

    if(key === 'Backspace') {
      setCurrentLetters(currentLetters.splice(0,currentLetters.length-1));
      return;
    }

    if(key === 'Enter' && currentLetters.length === MAX_LETTERS) {
      if(currentRow < MAX_TRIES) {
        const word = currentLetters.map(({letter}) => letter).join('');
        if (allowOnlyValidWords && !isAWord(word)) {
          alert(`${word} Sanaa ei löydy tietokannasta`);
          return
        }

        const results = calculateResults(currentLetters.map(i => i.letter).join(''), SELECTED_WORD.join(''))
        addTry(results)
        setTries(tries.concat([results]));
        setCurrentRow(currentRow+1);
        setCurrentLetters([]);
      }
      return;
    }

    if(ALLOWED_KEYS.indexOf(key) < 0) {
      return
    }

    if(currentLetters.length < MAX_LETTERS) {
      setCurrentLetters(currentLetters.concat([{
        letter: key.toUpperCase()
      }]));
    }
  }, [currentLetters,setCurrentLetters, currentRow,gameIsOver,tries, addTry]);

  const rows = React.useMemo(() => {
    return new Array(MAX_TRIES)
      .fill(undefined)
      .map((_,index) => (
        <Row
          key={`row-${index}`}
          maxLetters={MAX_LETTERS}
          letters={index === currentRow ? currentLetters : tries[index] ? tries[index] : []}
        />
      ));
  }, [tries, currentLetters, currentRow])

  const handler = ({key}:KeyboardEvent) => {
    onClickLetter(key);
  };

  useEventListener("keydown", handler);

  return (
    <div className="BoardView">
      { gameIsOver && (
        <GameOver win={playerWon} correctWord={SELECTED_WORD.join('')} tries={tries} wordNumber={getWordNumber()}/>
      )}
      <div className="Board">
        {rows}
      </div>
      <UsedLetters onClick={onClickLetter} allLetters={KEY_ROWS} tries={tries} />
    </div>
  );
}

export default Board;
